import { ChevronDownIcon, CloseIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import {
  Box, Button, ButtonGroup, Checkbox, CheckboxGroup, Divider, Flex, Icon,
  IconButton,
  Image,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio, RadioGroup,
  Select,
  Table,
  Tbody,
  Td,
  Text, Textarea,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import AiImageModal from 'components/aiHub/AiImageModal';
import AiVideoModal from 'components/aiHub/AiVideoModal';
import DriveModal from 'components/drive/DriveModal';
import ReplaceDriveModal from 'components/drive/ReplaceDriveModal';
import DeleteConfirmationModal from 'components/genericForms/DeleteConfirmationModal';
import { useFormik } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { BsStars } from 'react-icons/bs';
import { FaExchangeAlt } from 'react-icons/fa';
import { MdDelete, MdEdit } from "react-icons/md";
import PhoneInput from 'react-phone-input-2';
import { useSelector } from 'react-redux';
import { useCreateAdspressoCreativeMutation, useRemoveAdMutation, useUpdateAdspressoAdCreativeByIdMutation } from 'store/adspresso/adspressoAdApi';
import { useGetInstantFormsByPageIdQuery } from 'store/campaigns/adsApi';
import {
  call_to_action_options,
  call_to_action_options_app_promptions,
  call_to_action_options_instantForms
} from 'utils/callToActions';
import { formatDateTime, getFileNameWithoutExtension, getStepMeta, removeEmptyValues, StepButton, truncateString } from 'utils/functions';
import imagePlacementConfig from 'utils/imagePlacementConfig.json';
import videoPlacementConfig from 'utils/videoPlacementConfig.json';
import { object, string } from "yup";
import BuildUrlParams from './BuildUrlParams';
import UrlParameter from './UrlParameter';
import DriveComponent from 'components/drive/DriveComponent';
import ReplaceComponent from 'components/genericForms/ReplaceComponent';

function isValidUrl(url) {
  const regex = /^(https?:\/\/)?([\w\d\-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  return regex.test(url);
}

const isValidPhoneNumber = (phoneNumber) => {
  const countryCodePattern = /^[0-9]{2}/;
  const phoneNumberPart = phoneNumber.slice(2); // Remove the first 2 digits (country code)
  const regex = /^[0-9]{10}$/;
  return countryCodePattern.test(phoneNumber) && regex.test(phoneNumberPart);
};

function SizeMediaCreative({ adsAccounts, adFormik, adsetsListData, objective, campaignId, adData }) {

  const toast = useToast();
  const bgGradient = useColorModeValue(
    "linear-gradient(180deg, #f8f6fb 10%, #b0a8bf 130%)", 
    "linear-gradient(180deg, #1a202c 10%, #1b1845 130%)"   
  );
  const boxBorder = useColorModeValue("gray.200", "gray.700");
  const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
  const { isOpen: isEditModalOpen, onOpen: OnEditModalOpen, onClose: OnEditModalClose } = useDisclosure();
  const { isOpen: isReplaceModalOpen, onOpen: OnReplaceModalOpen, onClose: OnReplaceModalClose } = useDisclosure();
  const { isOpen: isAiImageModalOpen, onOpen: onAiImageModalOpen, onClose: onAiImageModalClose } = useDisclosure();
  const { isOpen: isAiVideoModalOpen, onOpen: onAiVideoModalOpen, onClose: onAiVideoModalClose } = useDisclosure();
  const { isOpen: isCreativeModalOpen, onOpen: onCreativeModalOpen, onClose: onCreativeModalClose} = useDisclosure();
  const [activeStep, setActiveStep] = useState("Media"); // 'Media' | 'Replace'
  const [hasSelectedFiles, setHasSelectedFiles] = useState(false);
  const [isDriveOpen, setIsDriveOpen] = useState(false);
  const [mediaType, setMediaType] = useState(null);
  const [uploadPurpose, setuploadPurpose] = useState(null);
  const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
  const [selectedAdSets, setSelectedAdSets] = useState({});
  const [mediaFiles, setMediaFiles] = useState([]);
  const [selectedMediaUrls, setselectedMediaUrls] = useState([]);
  const [fileBeingEdited, setFileBeingEdited] = useState(null);
  const [hasSameDestinationType, sethasSameDestinationType] = useState(true);
  const [activeDestinationType, setactiveDestinationType] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const userInfo = useSelector((state) => state.auth?.userInfo);
  const [isUrlModalOpen, setUrlModalOpen] = useState(false);
  const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [links, setLinks] = useState([]);
  const [customIds, setCustomIds] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [url_tags, seturl_tags] = useState([]);
  const [isFocused, setIsFocused] = useState({});
  const [editingGroupIndex, setEditingGroupIndex] = useState(null);
  const [replacingIndex, setReplacingIndex] = useState({ groupIndex: null, placementIndex: null });


  const [createAdspressoAds, { isLoading: isAdsCreating, error: createError }] = useCreateAdspressoCreativeMutation();
  const [updateAdspressocreativeAds, { isLoading: isAdspressoAdsetUpdating }] = useUpdateAdspressoAdCreativeByIdMutation({});
  const [removeAd, removeAdResponse] = useRemoveAdMutation();
  const isInstantFormAvailable = adsetsListData?.data?.some(adset =>
    adset?.destination_type === "ON_AD" &&
    objective === "OUTCOME_LEADS"
  );

  const pageIds = adData?.adsAccounts.map(account => account?.page_id);

  const { data: instantForms, isLoading: isInstantFormsLoading, error: instantFormsError } = useGetInstantFormsByPageIdQuery(
    { pageIds },
    { skip: !pageIds.length || !isInstantFormAvailable }
  );

  const handleMediaTypeChange = (adAccounts, type) => {
    setSelectedAdAccounts(adAccounts);
    setMediaType(type);
    setHasSelectedFiles(false);
    onCreativeModalOpen();
  }

  const handleAdAccountChange = (selectedValues) => {
    const selectedAccounts = adsAccounts.filter(account => selectedValues.includes(account.adsAccountId));
    setSelectedAdAccounts(selectedAccounts);

    // Filter out media files associated with deselected accounts
    const updatedMediaFiles = mediaFiles.filter(file =>
      selectedValues.includes(file?.adsAccount?.adsAccountId)
    );
    setMediaFiles(updatedMediaFiles);

    // Filter selectedMediaUrls similarly — keep only inner arrays where the adsAccountId matches selectedValues
    const updatedSelectedMediaUrls = selectedMediaUrls
      .map(mediaGroup => mediaGroup.filter(media => selectedValues.includes(media.adsAccountId)))
      .filter(mediaGroup => mediaGroup.length > 0); // remove empty inner arrays

    setselectedMediaUrls(updatedSelectedMediaUrls);

    // Update links state with initial empty URLs for selected ad accounts
    setLinks(prevLinks => {
      const updatedLinks = selectedAccounts.map(account => ({
        adsAccountId: account?.adsAccountId,
        link: prevLinks.find(link => link?.adsAccountId === account?.adsAccountId)?.link || '' // keep previous value if exists
      }));
      return updatedLinks;
    });

    // Update phoneNumbers state with initial empty phone numbers for selected ad accounts
    setPhoneNumbers(prevPhoneNumbers => {
      const updatedPhoneNumbers = selectedAccounts.map(account => ({
        adsAccountId: account?.adsAccountId,
        phoneNumber: prevPhoneNumbers.find(phone => phone?.adsAccountId === account?.adsAccountId)?.phoneNumber || '' // keep previous value if exists
      }));
      return updatedPhoneNumbers;
    });

    setCustomIds(prevIds => {
      const updatedIds = selectedAccounts.map(account => ({
        adsAccountId: account?.adsAccountId,
        app_product_page_id: prevIds.find(id => id?.adsAccountId === account?.adsAccountId)?.app_product_page_id || '' // keep previous value if exists
      }));
      return updatedIds;
    });

    seturl_tags(prevUrl => {
      const updatedurl_tags = selectedAccounts.map(account => ({
        adsAccountId: account?.adsAccountId,
        url_tags: prevUrl.find(url => url?.adsAccountId === account?.adsAccountId)?.url_tags || '' // keep previous value if exists
      }));
      return updatedurl_tags;
    });
  };

  const handleAdSetChange = (selectedValues) => {

    setSelectedAdSets(prev => {
      const updated = {};
      selectedAdAccounts.forEach(account => {
        updated[account.adsAccountId] = selectedValues;
      });
      return updated;
    });
  };

  const handleFileSelect = (files) => {
    if (files.length > 0){
        // Handle creation scenario
        setMediaFiles(prevFiles => [...prevFiles, ...files])

        if (activeDestinationType === 'APP') {
          const placements = ['square', 'vertical', 'horizontal'];

          const fileData = files.map((file) =>
            placements.map((placement) => ({
              placement,
              url: file?.url ? file?.url : file?.picture,
              source: file?.source,
              mediaType: file?.url ? 'image' : 'video',
              hash: file?.creativeId,
              mediaHash: file?.hash,
              name: file?.name,
              adsAccountId: file?.adsAccount?.adsAccountId,
              adsAccountName: file?.adsAccount?.adsAccountName
            }))
          );

          setselectedMediaUrls(prev => [...prev, ...fileData]);

        }
      }
  };

  let schema = object().shape({
    destinationType: string(),
    type: string()
      .required('Type is required'),
    // message: string().required('Text required'),
    // link: string()
    //   .url('Please add a valid URL')
    //   .when('destinationType', {
    //     is: 'WEBSITE',
    //     then: () => string().required('Website URL is required'),
    //     otherwise: () => string().notRequired(),
    //   }),
    // link: array().of(
    //   object().shape({
    //     adsAccountId: string().required('Ads Account ID is required'),
    //     link: string()
    //       .url('Please add a valid URL')
    //       .when('destinationType', {
    //         is: 'WEBSITE',
    //         then: () => string().required('Website URL is required'),
    //         otherwise: () => string().notRequired(),
    //       })
    //   })
    // )
    //   .when('destinationType', {
    //     is: 'WEBSITE',
    //     then: () => array().min(1, 'At least one website URL is required'),
    //     otherwise: () => array().notRequired(),
    // }),

    // phoneNumber: string().
    //   when('destinationType', {
    //     is: 'PHONE_CALL',
    //     then: () => string().required('Phone number is required'),
    //     otherwise: () => string().notRequired(),
    //   })
    //   .min(10, 'Phone number is too short')
    //   .max(15, 'Phone number is too long'),
  })

  const singleMediaFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      destinationType: activeDestinationType,
      message: '',
      name: '',
      description: '',
      type: activeDestinationType === 'WEBSITE' ? 'SHOP_NOW' : (activeDestinationType === 'PHONE_CALL' ? 'CALL_NOW' : activeDestinationType === 'APP' ? 'INSTALL_MOBILE_APP' : 'SIGN_UP'),
      applyForAll: false,
      message: '',
      mediaFiles: [],
      link: [],
      customId: [],
      phoneNumber: [],
      url_tags: [],
    },
    validationSchema: schema,
    onSubmit: (values, { resetForm }) => {

      const { name, message, description, type, link, phoneNumber, customId } = values;

      const matchingGroups = [];
      const nonMatchingGroups = [];

      selectedMediaUrls.forEach(group => {
        const allMatch = group.every(item => item.hash === group[0].hash);
        if (allMatch) {
          matchingGroups.push(group);
        } else {
          nonMatchingGroups.push(group);
        }
      });

      let allMediaData = [];
      let allAssetCustomizationRules = [];


      nonMatchingGroups.forEach(group => {
        const hashMap = {};
        const seenHashes = new Set();
        const hashDuplicates = new Map();

        // Step 1: Build hashMap
        group.forEach(item => {
          hashMap[item.hash] = {
            mediaType: item.mediaType,
            placement: item.placement
          };
        });

        // Step 2: Identify duplicates
        group.forEach(item => {
          if (seenHashes.has(item.hash)) {
            if (!hashDuplicates.has(item.hash)) {
              hashDuplicates.set(item.hash, []);
            }
            hashDuplicates.get(item.hash).push(item.placement);
          } else {
            seenHashes.add(item.hash);
          }
        });

        // Reset for second pass
        seenHashes.clear();

        // Step 3: Deduplicate & tag
        const mediaData = group
          .filter(item => {
            if (seenHashes.has(item.hash)) return false;
            seenHashes.add(item.hash);
            return true;
          })
          .map(item => {
            const duplicatePlacements = hashDuplicates.get(item.hash);
            const tag = duplicatePlacements?.length
              ? { duplicatePlacements }
              : undefined;

            return {
              [item.mediaType === 'image' ? 'hash' : 'video_id']: item.hash,
              thumbnail_url: item.url,
              [item.mediaType === 'image' ? 'creative_hash' : 'hash']: item.mediaHash,
              adlabels: [{ name: item.placement }],
              ...(tag && { tag }),
              fileName: item?.name,
              mediaType: item.mediaType,
              adsAccountId: item?.adsAccountId,
            };
          });

        // Step 4: Build asset_customization_rules
        const asset_customization_rules = mediaData.map(media => {
          const meta = hashMap[media.mediaType === 'image' ? media.hash : media.video_id];
          if (!meta) return null;

          const { mediaType } = meta;
          const isDuplicate = media.tag?.duplicatePlacements?.length > 0;

          return (media.adlabels || []).map(label => {
            const placement = label.name;
            if (!placement) return null;

            return {
              [mediaType === 'image' ? 'image_label' : 'video_label']: { name: placement },
              customization_spec: isDuplicate
                ? {}
                : (mediaType === 'image' ? imagePlacementConfig : videoPlacementConfig)[placement] || {}
            };
          });
        }).flat().filter(Boolean); // flatten & remove nulls

        // Merge into global arrays
        allMediaData.push(mediaData);
        allAssetCustomizationRules.push(asset_customization_rules);
      });

      const adsAccounts = selectedAdAccounts?.map(account => ({
        id: account?.id,
        adsAccountId: account?.adsAccountId,
        adsAccountName: account?.adsAccountName,
        businessName: account?.businessName,
        businessId: account?.businessId,
      }));


      // Step 1: Flatten selected ad sets
      const adsets = adsAccounts.flatMap(account => selectedAdSets[account.adsAccountId] || []);

      // Step 2: Deduplicate by `_id`
      const uniqueAdsets = adsets.filter(
        (item, index, self) => index === self.findIndex(i => i._id === item._id)
      );

      // Step 3: Enrich with `promoted_object` from adsetsListData
      const enrichedAdsets = uniqueAdsets.map(selected => {
        const matched = adsetsListData?.data?.find(adset => adset._id === selected);
        return {
          promoted_object: matched?.promoted_object || {}
        };
      });

      const adcreatives = allMediaData.map((mediaGroup, index) => {
        const rules = allAssetCustomizationRules[index];
        const representative = mediaGroup[0];

        const adsAccountId = representative?.adsAccountId || '';
        const strippedName = getFileNameWithoutExtension(representative?.fileName)?.trim();
        const fileName = strippedName ? strippedName : `Ad_${formatDateTime()}`;

        const matchedLink = link.find(item => item.adsAccountId === adsAccountId)?.link;
        const matchedAppId = customId.find(item => item.adsAccountId === adsAccountId)?.app_product_page_id;

        const matchedPromotedObject = enrichedAdsets
          ?.find(entry => Array.isArray(entry.promoted_object))
          ?.promoted_object?.find(obj => obj.adsAccountId === adsAccountId);

        const website_url = matchedPromotedObject?.object_store_url || '';

        // Clean out  from mediaGroup
        const cleanedMediaGroup = mediaGroup.map(({ tag, fileName, mediaType, adsAccountId, ...rest }) => rest);

        return {
          fileName,
          adsAccountId,
          [representative?.mediaType === 'image' ? 'url' : 'thumbnail']: representative?.thumbnail_url || '',
          asset_feed_spec: {
            optimization_type: 'PLACEMENT',
            ad_formats: [representative?.mediaType === 'image' ? 'SINGLE_IMAGE' : 'SINGLE_VIDEO'],
            [representative?.mediaType === 'image' ? 'images' : 'videos']: cleanedMediaGroup,
            asset_customization_rules: rules,
            ...(message && { bodies: [{ text: message }] }),
            ...(name && { titles: [{ text: name }] }),
            call_to_action_types: [type],
            link_urls: [{
              deeplink_url: matchedLink,
              website_url
            }],
            ...(matchedAppId && { app_product_page_id: matchedAppId }),
          },
        };
      });

      const matchedAdCreatives = matchingGroups.map(group => {
        const file = group[0];
        const adsAccountId = file?.adsAccountId || '';
        const matchedAppId = customId.find(item => item.adsAccountId === adsAccountId)?.app_product_page_id;
        const strippedName = getFileNameWithoutExtension(file?.name)?.trim();
        const fileName = strippedName ? strippedName : `Ad_${formatDateTime()}`;

        return {
          adsAccountId: file?.adsAccountId || '',
          fileName: fileName,
          hash: file?.mediaHash || '',
          [file.mediaType === 'image' ? 'image_hash' : 'video_id']: file?.hash,
          url: file.mediaType === 'image' ? file?.url || '' : file?.source || '',
          thumbnail: file?.mediaType === 'video' ? file?.url || '' : '',
          ...(matchedAppId && { asset_feed_spec: { app_product_page_id: matchedAppId } }),
        };
      });

      matchedAdCreatives.forEach(item => adcreatives.push(item));

      const intialPayload = {
        adType: adFormik.values.format,
        contextual_multi_ads: {
          enroll_status: adFormik.values.enroll_status,
        },
        campaign: campaignId,
        adsets: uniqueAdsets,
        ...(message?.trim() && { message }),
        name: name,
        description: description,
        type: phoneNumber?.length ? 'CALL_NOW' : type,
        ...(phoneNumber?.length
          ? {
            links: phoneNumber.map(item => ({
              adsAccountId: item.adsAccountId,
              link: `tel:+${item.phoneNumber}`
            }))
          }
          : { links: link }
        ),
        adcreatives: adcreatives,
        adsAccounts: adsAccounts,
      };

      const payload = removeEmptyValues(intialPayload);

      try {
        if (uploadPurpose === 'create') {

          createAdspressoAds(payload).unwrap()
            .then(response => {
              toast({
                position: "top-right",
                title: "Ad creative added",
                status: "success",
                duration: 4000,
                isClosable: true,
              });
              // console.log('Ads creative created successfully:', response);
            })
            .catch(error => {
              const errorMessage = error?.message || "An unexpected error occurred";

              toast({
                position: "top-right",
                title: "Error creating Ad creative",
                description: errorMessage,
                status: "error",
                duration: 4000,
                isClosable: true,
              });
            });
        }
      } catch {
      } finally {
        setuploadPurpose(null);
        setMediaType(null);
        setMediaFiles([]);
        setSelectedAdAccounts([]);
        setSelectedAdSets({});
        resetForm();
        setactiveDestinationType('');
        setselectedMediaUrls([]);
        setLinks([]);
        setCustomIds([]);
        setPhoneNumbers([]);
        seturl_tags([]);
      }
    },
  });

  const handleDeleteFile = (indexToDelete) => {
    setMediaFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToDelete));
    setselectedMediaUrls((prevFiles) => prevFiles.filter((_, index) => index !== indexToDelete));
  };

  const handleEditPlacement = (indexToEdit) => {
    setEditingGroupIndex(indexToEdit);
    OnEditModalOpen();
  };

  const handleReplaceImage = (type, groupIndex, placementIndex) => {
    setMediaType(type);
    setReplacingIndex({ groupIndex, placementIndex });
    OnReplaceModalOpen();
  };

  const handleImageSelectedFromReplaceDrive = (file) => {
    if (file && file.length > 0) {
      const newImage = file[0];

      // --- Update selectedMediaUrls ---
      setselectedMediaUrls((prev) =>
        prev.map((group, groupIdx) => {
          if (groupIdx !== replacingIndex.groupIndex) return group;
          // Replace only the placement within the correct group
          return group.map((placementItem, placementIdx) => {
            if (placementIdx !== replacingIndex.placementIndex) return placementItem;

            return {
              ...placementItem,
              url: newImage?.url || newImage?.picture,
              hash: newImage?.creativeId,
              mediaHash: newImage?.hash,
              name: newImage?.name,
              source: newImage?.source,
            };
          });
        })
      );

      // --- Update mediaFiles ---
      setMediaFiles((prev) =>
        prev.map((media, index) => {
          if (index !== replacingIndex.groupIndex) return media;

          return {
            ...newImage
          };
        })
      );
    }

    setReplacingIndex(null);
    OnReplaceModalClose();
  };

  useEffect(() => {
    singleMediaFormik.setFieldValue('mediaFiles', mediaFiles)
  }, [mediaFiles])

  const handleDeleteAd = (adId) => {
    removeAd(adId)
      .unwrap()
      .then(response => {
        toast({
          position: "top-right",
          title: "Ad deleted",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      })
      .catch(error => {
        toast({
          position: "top-right",
          title: "Error deleting Ad",
          status: "error",
          description: error?.data?.message,
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const confirmDelete = () => {
    if (selectedAd) {
      handleDeleteAd(selectedAd);
      setModalOpen(false);
      setSelectedAd(null);
    }
  };

  function checkSameDestinationType(selectedIds, adsets) {
    const filteredAdsets = adsets.filter(adset => selectedIds.includes(adset._id));

    if (filteredAdsets.length === 0) {
      return true;
    }

    // Get the destination_type of the first filtered adset
    const firstDestinationType = filteredAdsets[0].destination_type;

    // Loop through the filtered adsets and check if all have the same destination_type
    for (let i = 1; i < filteredAdsets.length; i++) {
      if (filteredAdsets[i].destination_type !== firstDestinationType) {
        return false;
      }
    }

    setactiveDestinationType(firstDestinationType);


    return true;
  }

  useEffect(() => {
    // console.log(checkSameDestinationType(Object.values(selectedAdSets).flat(), adsetsListData?.data))
    if (Object.values(selectedAdSets)?.flat()?.length > 1) {
      const checkresult = checkSameDestinationType(Object.values(selectedAdSets).flat(), adsetsListData?.data);
      sethasSameDestinationType(checkresult)
    } else if (Object.values(selectedAdSets)?.flat()?.length == 1) {
      //console.log(String(Object.values(selectedAdSets)?.flat()?.[0]));
      let activeSingleAdset = adsetsListData?.data?.filter((adset) => adset._id == String(Object.values(selectedAdSets)?.flat()?.[0]));
      // console.log(activeSingleAdset);
      setactiveDestinationType(activeSingleAdset?.[0]?.destination_type)
      sethasSameDestinationType(true)
    } else {
      setactiveDestinationType('')
    }

  }, [selectedAdSets])


  const handleLinkChange = (adsAccountId, value) => {
    setLinks(prevLinks => {
      const updatedLinks = prevLinks.map(link =>
        link.adsAccountId === adsAccountId ? { ...link, link: value } : link
      );
      singleMediaFormik.setFieldValue('link', updatedLinks);
      return updatedLinks;
    });
  };

  const handleCustomIdChange = (adsAccountId, value) => {
    setCustomIds(prevIds => {
      const updatedIds = prevIds.map(ids =>
        ids.adsAccountId === adsAccountId ? { ...ids, app_product_page_id: value } : ids
      );
      singleMediaFormik.setFieldValue('customId', updatedIds);
      return updatedIds;
    });
  };

  const handleUrlChange = (constructedUrl, adsAccountId) => {
    setLinks((prevLinks) => {
      const updatedLinks = prevLinks.map((link) =>
        link.adsAccountId === adsAccountId ? { ...link, link: constructedUrl } : link
      );
      singleMediaFormik.setFieldValue('link', updatedLinks);
      return updatedLinks;
    });
  };

  const handlePhoneNumberChange = (adsAccountId, value) => {
    setPhoneNumbers(prevPhoneNumbers => {
      const updatedPhoneNumbers = prevPhoneNumbers.map(phone =>
        phone.adsAccountId === adsAccountId ? { ...phone, phoneNumber: value } : phone
      );
      singleMediaFormik.setFieldValue('phoneNumber', updatedPhoneNumbers); // Update formik field
      return updatedPhoneNumbers;
    });
  };

  const handleUrlTagChange = (adsAccountId, value) => {
    seturl_tags(prevUrl => {
      const updatedUrl = prevUrl.map(url =>
        url.adsAccountId === adsAccountId ? { ...url, url_tags: value } : url
      );
      singleMediaFormik.setFieldValue('url_tags', updatedUrl);
      return updatedUrl;
    });
  };

  const handleUrlParamChange = (constructedUrl, adsAccountId) => {
    seturl_tags(prevUrl => {
      const updatedUrl = prevUrl.map(url =>
        url.adsAccountId === adsAccountId ? { ...url, url_tags: constructedUrl } : url
      );
      singleMediaFormik.setFieldValue('url_tags', updatedUrl);
      return updatedUrl;
    });
  };

  const handleAiUploadedMedia = (data) => {
    const mappedMediaFiles = data.map(item => {
      const dynamicKeyData = item[item?.name] || {};

      return {
        creativeType: item?.creativeType,
        creativeId: item?.creativeId,
        source: item?.source,
        url: dynamicKeyData?.url || "",
        picture: dynamicKeyData?.url || "",
        hash: item?.hash,
        name: item?.name,
        adsAccount: {
          adsAccountId: item?.adsAccount?.adsAccountId
        }
      };
    });

    // Update media files
    setMediaFiles(prevFiles => [...prevFiles, ...mappedMediaFiles]);

    if (activeDestinationType === 'APP') {
      const placements = ['square', 'vertical', 'horizontal'];

      const fileData = mappedMediaFiles.map((file) =>
        placements.map((placement) => ({
          placement,
          url: file?.url ? file?.url : file?.picture,
          source: file?.source,
          mediaType: file?.url ? 'image' : 'video',
          hash: file?.creativeId,
          mediaHash: file?.hash,
          name: file?.name,
          adsAccountId: file?.adsAccount?.adsAccountId
        }))
      );

      setselectedMediaUrls(prev => [...prev, ...fileData]);

    }
  };

  const allLinksAdded = (activeDestinationType === 'WEBSITE' || activeDestinationType === 'ON_AD') && links.every(link => link?.link !== '');

  const allPhoneNumbersAdded = activeDestinationType === 'PHONE_CALL' &&
    phoneNumbers.every(phone => phone?.phoneNumber !== '');

  const handleFocus = (adsAccountId) => {
    // Set the field as focused when the user starts typing
    setIsFocused(prev => ({
      ...prev,
      [adsAccountId]: true
    }));
  };


  const isAccountsMatching = !singleMediaFormik.values.mediaFiles.every(mediaFile =>
    selectedAdAccounts.some(account => account.adsAccountId === mediaFile.adsAccount?.adsAccountId)
  ) ||
    !selectedAdAccounts.every(account =>
      singleMediaFormik.values.mediaFiles.some(mediaFile => mediaFile.adsAccount?.adsAccountId === account.adsAccountId)
  )

  const getSelectedAccountFromMediaUrls = () => {
    if (
      editingGroupIndex !== null && 
      selectedMediaUrls && 
      selectedMediaUrls[editingGroupIndex] && 
      selectedMediaUrls[editingGroupIndex].length > 0
    ) {
      const { adsAccountId, adsAccountName } = selectedMediaUrls[editingGroupIndex][0];
      return [{ adsAccountId, adsAccountName }];
    }
    return [];
  };

  // Group mediaFiles by adsAccountId and keep original index for delete/edit
  const groupedByAccount = useMemo(() => {
    const withIdx = mediaFiles.map((m, idx) => ({ ...m, __idx: idx }));
    return withIdx.reduce((acc, item) => {
      const accountId = item?.adsAccount?.adsAccountId || item?.adsAccountId || 'unknown';
      const accountName = item?.adsAccount?.adsAccountName || item?.adsAccountName || accountId;

      if (!acc[accountId]) {
        acc[accountId] = { accountId, accountName, items: [] };
      }
      acc[accountId].items.push(item);
      return acc;
    }, {});
  }, [mediaFiles]);

  return (
    <>
     <Modal
        isOpen={isCreativeModalOpen}
        onClose={() => {
          onCreativeModalClose();
          setMediaType(null);
        }}
        isCentered
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent maxW={{ base: "95vw", md: "80vw" }} minH="80vh">
          <Divider />
          <ModalBody p={0}>
            <Flex minH="90vh" w="100%">
              {/* Sidebar */}
              <Box
                w={{ base: "260px", md: "200px" }}
                bgGradient={bgGradient}
                borderRight="1px solid"
                borderColor={useColorModeValue("gray.200", "whiteAlpha.300")}
                px={4}
                py={3}
              >
                <Text fontWeight={"bold"} mb={4}>
                  Set up your creative
                </Text>
                <ButtonGroup orientation="vertical" spacing={3} display="flex" flexDir="column">
                  <StepButton isActive={activeStep === "Media"} onClick={() => setActiveStep("Media")}>
                    Media
                  </StepButton>
                  <Tooltip
                      label="Finish the Media step to proceed to the Replace."
                      isDisabled={hasSelectedFiles}
                      placement="bottom"
                      fontSize={'12px'}
                      hasArrow
                    >
                      <span>
                        <StepButton
                          isActive={activeStep === "Replace"}
                          onClick={() => setActiveStep("Replace")}
                          isDisabled={!hasSelectedFiles}
                        >
                          Replace
                        </StepButton>
                      </span>
                  </Tooltip>
                </ButtonGroup>
              </Box>

              {/* Main content area */}
              <Box flex="1" py={3} px={2}>
                {/* Dynamic header with close button */}
                {(() => {
                  const meta = getStepMeta(activeStep, mediaType);
                  return (
                    <Box position="sticky" top={0} zIndex={1}>
                      <Flex>
                        <Flex gap={1} direction={"column"} flex={"98%"}>
                          <Text fontWeight={"bold"}>{meta.title}</Text>
                          <Text fontSize="12px">
                            {meta.desc}
                          </Text>
                        </Flex>
                        <Flex flex={"2%"}>
                          <IconButton
                            aria-label="Close"
                            icon={<CloseIcon boxSize={3} />}
                            variant="ghost"
                            onClick={() => {
                              onCreativeModalClose();
                              setMediaType(null);
                              setActiveStep('Media')
                            }}
                            size="sm"
                            alignSelf="flex-start"
                          />
                        </Flex>
                      </Flex>
                    </Box>
                  );
                })()}

                {/* Step body (swap your real components in) */}
                {activeStep === "Media" ? (
                  <DriveComponent
                    mediaType={mediaType}
                    selectedAdAccounts={selectedAdAccounts}
                    uploadPurpose={uploadPurpose}
                    onSubmit={handleFileSelect}
                    activeStep={"Media"}
                    setActiveStep={setActiveStep}
                    setHasSelectedFiles={setHasSelectedFiles}
                    onClose={() => {
                      onCreativeModalClose();
                      setMediaType(null);
                      setActiveStep('Media');
                      setHasSelectedFiles(false)
                    }}
                  />
                ) : (
                  <ReplaceComponent
                    selectedMediaUrls={selectedMediaUrls}
                    setselectedMediaUrls={setselectedMediaUrls}
                    mediaType={mediaType}
                    onClose={() => {
                      onCreativeModalClose();
                      setMediaType(null);
                      setActiveStep('Media');
                    }}
                    setMediaFiles={setMediaFiles}
                    setActiveStep={setActiveStep}
                  />
                )}
              </Box>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
        size={"2xl"}
        isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BuildUrlParams links={links} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} selectedAccountId={selectedAccountId} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
        size={"2xl"}
        isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <UrlParameter urls={url_tags} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} selectedAccountId={selectedAccountId} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isEditModalOpen} onClose={OnEditModalClose} scrollBehavior={"inside"} size={"5xl"} isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select media for placements</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <>
              <ReplaceDriveModal
                isDriveModalOpen={isReplaceModalOpen}
                selectedAdAccounts={selectedAdAccounts}
                onClose={() => {
                  OnReplaceModalClose();
                  setMediaType(null);
                }}
                onSubmit={handleImageSelectedFromReplaceDrive}
                uploadPurpose="update"
                mediaType={mediaType}
              />
              <Flex wrap="wrap" gap={2} justifyContent={'center'}>
                {selectedMediaUrls?.map((group, groupIndex) =>
                  group.map(({ placement, url, source, mediaType }, placementIndex) => {

                    const isEditing = editingGroupIndex !== null && editingGroupIndex === groupIndex;

                    return isEditing ? (
                      <Box
                        key={`${groupIndex}-${placement}`}
                        border="1px solid"
                        borderColor={'gray.100'}
                        borderRadius="md"
                        p={2}
                        width={'240px'}
                        height={
                          placement === 'square'
                            ? '300px'
                            : placement === 'vertical'
                              ? '530px'
                              : '230px'
                        }
                        display="flex"
                        flexDirection="column"
                        gap={2}
                      >
                        <Text fontWeight="bold" textTransform="capitalize">
                          {placement}
                        </Text>
                        {source ? (
                            <Box
                              width="220px"
                              height={
                                placement === 'square'
                                  ? '200px'
                                  : placement === 'vertical'
                                    ? '440px'
                                    : '120px'
                              }
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              bg="gray.200"
                              borderRadius="md"
                            >
                              <Box
                                as="video"
                                controls
                                src={source}
                                maxWidth="100%"
                                maxHeight="100%"
                                style={{ objectFit: 'contain', objectPosition: 'center' }}
                              />
                          </Box>
                        ) : (
                          <Box
                            width="220px"
                            height={
                              placement === 'square'
                                ? '200px'
                                : placement === 'vertical'
                                  ? '430px'
                                  : '120px'
                            }
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            bg="gray.200"               
                            borderRadius="md"
                          >
                            <Image
                              src={url}
                              alt={placement}
                              maxWidth="100%"
                              maxHeight="100%"
                              objectFit="contain"      
                              objectPosition="center"  
                            />
                          </Box>
                        )}
                        <Flex>
                          <Button
                            size="sm"
                            variant={'solid'}
                            colorScheme={'gray'}
                            mt={2}
                            leftIcon={<FaExchangeAlt />}
                            onClick={() =>
                              handleReplaceImage(mediaType, groupIndex, placementIndex)
                            }
                          >
                            Replace
                          </Button>
                        </Flex>
                      </Box>
                    ) : null;
                  })
                )}
              </Flex>
            </>
          </ModalBody>
          <ModalFooter gap={2}>
            <Button 
              colorScheme="gray"
              variant="solid"
              size={'sm'} 
              onClick={OnEditModalClose}
            >
              Cancel
            </Button>
            <Button colorScheme="brand" size={'sm'} onClick={OnEditModalClose}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isAiImageModalOpen}
        onClose={onAiImageModalClose} scrollBehavior={"inside"}
        size={"5xl"}
        isCentered={true}
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Flex gap={2} direction={'column'}>
              <Flex alignItems={'center'} gap={2}>
                <BsStars />
                <Text>AI Image Generation</Text>
                <Tooltip
                  borderRadius={5}
                  label={
                    <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                      <Text fontWeight={'bold'}>Generated with AI</Text>
                      <Text>AI-generated image variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                      <Flex direction={'column'} gap={2}>
                        <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                        <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                        <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                      </Flex>
                      <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                    </Flex>
                  }
                  fontSize="md"
                >
                  <InfoOutlineIcon pointerEvents="all" />
                </Tooltip>
              </Flex>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <AiImageModal selectedAdAccounts={selectedAdAccounts} onClose={onAiImageModalClose} onUploadComplete={handleAiUploadedMedia} />
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Upload Video Modal */}
      <Modal
        size={"6xl"}
        isCentered={true}
        isOpen={isAiVideoModalOpen}
        scrollBehavior={"inside"}
        onClose={onAiVideoModalClose}
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Flex gap={2} direction={'column'}>
              <Flex alignItems={'center'} gap={2}>
                <BsStars />
                <Text>AI Video Generation</Text>
                <Tooltip
                  borderRadius={5}
                  label={
                    <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                      <Text fontWeight={'bold'}>AI Video Generation</Text>
                      <Text>AI-generated video ads are created using your product information and visuals. By assembling product highlights, voiceovers, and dynamic visuals, the AI helps generate high-performing video ads optimised for various platforms.</Text>
                      <Flex direction={'column'} gap={2}>
                        <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                        <Text>Product URL Based: Extracts product details from your URL to auto-generate video content.</Text>
                        <Text>Asset Based: Uses your uploaded visuals to create fully edited video ads.</Text>
                      </Flex>
                      <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated videos.</Text>
                    </Flex>
                  }
                  fontSize="md"
                >
                  <InfoOutlineIcon pointerEvents="all" />
                </Tooltip>
              </Flex>
            </Flex>
          </ModalHeader>
          <ModalBody>
            <AiVideoModal
              isOpen={isAiVideoModalOpen}
              selectedAdAccounts={selectedAdAccounts}
              onClose={() => {
                onAiVideoModalClose();
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <DeleteConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={confirmDelete}
        message="Do you wish to proceed with deleting this Ad?"
      />

      <Flex flex="3" direction="column" gap={2}>
        <Flex direction="column" >
          {/* Ad Account Select */}
          <Flex direction={'column'} gap={'10px'} mb={'10px'}>
            <Text fontSize={'14px'} fontWeight={'bold'}>Select Ad accounts</Text>
            <CheckboxGroup
              colorScheme="brand"
              value={selectedAdAccounts.map(account => account.adsAccountId)}
              onChange={handleAdAccountChange}
              isDisabled={userInfo?.role !== 'client'}
            >
              {adsAccounts?.map(account => (
                <Box key={account.adsAccountId} px={'5px'} py={'2px'}>
                  <Checkbox value={account.adsAccountId}>
                    <Text fontSize={'14px'} noOfLines={2} maxWidth={'510px'}>
                      {/* {account.adsAccountName.length > 20
                          ? `${account.adsAccountName.substring(0, 20)}...`
                          : account.adsAccountName} */}
                      {account.adsAccountName}
                    </Text>
                  </Checkbox>
                </Box>
              ))}
            </CheckboxGroup>
          </Flex>


          {/* Ad Set Select */}
          <Flex direction="column" gap={'5px'} mb={'20px'}>
            <Text fontSize={'14px'} fontWeight={'bold'}>Select Ad sets</Text>
            <CheckboxGroup
              colorScheme="brand"
              value={Array.from(new Set(Object.values(selectedAdSets).flat()))}
              onChange={(e) => {
                handleAdSetChange(e);
              }}
              isDisabled={!selectedAdAccounts.length > 0}
            >
              {adsetsListData?.data?.map((adSet, index) => (
                <Box key={`${adSet._id}-${index}`} px={'5px'} py={'2px'}>
                  <Checkbox value={adSet._id} display={'flex'} flex={1}>
                    <Text fontSize={'14px'} noOfLines={2} maxWidth={'510px'}>{adSet?.name}</Text>
                  </Checkbox>
                </Box>
              ))}
            </CheckboxGroup>

            {!hasSameDestinationType ? (
              <Flex>
                <Text color="red.500" fontSize={'12px'}>Conversion goals don't match &nbsp;
                </Text>
                <Tooltip
                  borderRadius={5}
                  label={
                    <Box fontSize="14px" p="5px">
                      <Text>
                        The selected Ad sets have different conversion goals. Please select Ad sets with the same goal (either Website or Calls). You can create a separate set of Ads for the other conversion goal thereafter.
                      </Text>
                    </Box>
                  }
                  fontSize="md"
                >
                  <InfoOutlineIcon pointerEvents="all" color={'red.500'} boxSize={4} />
                </Tooltip>
              </Flex>
            ) : null}

          </Flex>

          {/* Single Select component for each adAccount */}
          <Flex direction="row" flexShrink={0} alignItems={'center'} justifyContent={'space-between'}>
            <Select
              placeholder={singleMediaFormik?.values?.format === 'CAROUSEL' ? "Add cards" : "Add media"}
              width={'150px'}
              name="mediaOption"
              borderRadius={'md'}
              value={mediaType || ""}
              onChange={(e) => {
                setuploadPurpose('create');
                handleMediaTypeChange(selectedAdAccounts, e.target.value);
              }}
              size="sm"
              isDisabled={Object.keys(selectedAdSets)?.length === 0 || !selectedAdAccounts?.length > 0 || !hasSameDestinationType}
            >
              <option value="image">{singleMediaFormik?.values?.format === 'CAROUSEL' ? "Add image cards" : "Add image"}</option>
              <option value="video">{singleMediaFormik?.values?.format === 'CAROUSEL' ? "Add video cards" : "Add video"}</option>
            </Select>

            <Flex alignItems={'center'} gap={2}>
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme='brand'
                  size='sm'
                  _expanded={{ bg: 'orange.600' }}
                  rightIcon={<ChevronDownIcon boxSize={5} />}
                  isDisabled={Object.keys(selectedAdSets)?.length === 0 || !selectedAdAccounts?.length > 0 || !hasSameDestinationType}
                >
                  <Flex align="center">
                    <Icon as={BsStars} boxSize={4} mr={2} />
                    AI Generation
                  </Flex>
                </MenuButton>
                <MenuList sx={{ minWidth: "180px" }}>
                  <MenuItem onClick={onAiImageModalOpen} fontSize='14px'>
                    Generate Image
                  </MenuItem>
                  <MenuItem onClick={onAiVideoModalOpen} fontSize='14px'>
                    Generate Video
                  </MenuItem>
                </MenuList>
              </Menu>

              <Tooltip
                borderRadius={5}
                label={
                  <Flex direction={'column'} gap={4} fontSize="12px" p="5px">
                    <Flex direction={'column'} gap={2}>
                      <Text fontWeight={'bold'}>AI Image Generation</Text>
                      <Text>AI-generated image variations are inspired by your original asset.</Text>
                      <Flex direction={'column'} gap={2}>
                        <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                        <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                        <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                      </Flex>
                    </Flex>
                    <Flex direction={'column'} gap={2}>
                      <Text fontWeight={'bold'}>AI Video Generation</Text>
                      <Text>AI-generated video ads are created using your product information, images, or scripts.</Text>
                      <Flex direction={'column'} gap={2}>
                        <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                        <Text>Product URL Based: Generates video using product details pulled from your URL.</Text>
                        <Text>Asset Based: Combines your visual assets into fully edited video ads.</Text>
                      </Flex>
                    </Flex>
                    <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated assets.</Text>
                  </Flex>
                }
                fontSize="md"
              >
                <InfoOutlineIcon pointerEvents="all" />
              </Tooltip>
            </Flex>
          </Flex>

          {/*  Media Previews */}
          {mediaFiles?.length > 0 && (
            <Box mt={'10px'}>
              {Object.values(groupedByAccount).map((group) => (
                <Box
                  key={group.accountId}
                  mb={2}
                  p={3}
                  borderWidth={1}
                  borderRadius="md"
                  borderColor={boxBorder}
                >
                  <Flex align="center" justify="space-between" mb={3}>
                    <Text fontWeight="bold" fontSize="14px">
                      {group.accountName}
                    </Text>
                  </Flex>

                  <Flex wrap="wrap" gap="10px">
                    {group.items.map((file) => (
                      <Box
                        key={file.__idx}
                        p={1}
                        borderWidth={1}
                        borderRadius="md"
                        borderColor={boxBorder}
                        bg={backgroundColor}
                      >
                        <Box width="80px">
                          {file?.creativeType === 'image' ? (
                            <img
                              src={file?.url}
                              alt={file?.name}
                              style={{ width: '80px', height: '60px',  objectFit: 'cover', borderRadius: '3px' }}
                            />
                          ) : (
                            <img
                              src={file?.picture}
                              style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '3px' }}
                            />
                          )}
                          <Text fontSize="10px" noOfLines={1}>
                            {truncateString(file?.name, 16)}
                          </Text>
                        </Box>

                        <Flex mt="5px" gap="5px" align="center" justify="space-between">
                          {['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(activeDestinationType) ? (
                            <Flex />
                          ) : (
                            <Tooltip label="Edit Media" fontSize="xs">
                              <Box height="20px">
                                <Icon
                                  _hover={{ color: 'gray.400' }}
                                  as={MdEdit}
                                  cursor="pointer"
                                  fontSize="18px"
                                  onClick={() => handleEditPlacement(file.__idx)}
                                />
                              </Box>
                            </Tooltip>
                          )}

                          <Tooltip label="Remove Media" fontSize="xs">
                            <Box height="20px">
                              <Icon
                                color="red.500"
                                _hover={{ color: 'gray.400' }}
                                as={MdDelete}
                                cursor="pointer"
                                fontSize="18px"
                                onClick={() => handleDeleteFile(file.__idx)}
                              />
                            </Box>
                          </Tooltip>
                        </Flex>
                      </Box>
                    ))}
                  </Flex>
                </Box>
              ))}
            </Box>
          )}
        </Flex>

        <Divider mt={'10px'} />

        <Box direction="column" mb={4}>
          <Flex alignItems="center" mb={2}>
            <Text fontWeight="bold" fontSize={'14px'} mr={2}>Primary text</Text>
            {/* <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text> */}
            <Tooltip
              borderRadius={5}
              label={
                <Box fontSize="sm" p="5px">
                  <Text>
                    The primary text for your ad appears in most placements, though the position
                    varies. You can use @ to tag Facebook profiles or Pages. We recommend 125
                    characters or less.
                  </Text>
                </Box>
              }
              fontSize="md">
              <InfoOutlineIcon pointerEvents="all" />
            </Tooltip>
          </Flex>
          <Textarea
            size={'sm'}
            placeholder="Tell people what your ad is about..."

            name="message"
            value={singleMediaFormik.values.message}
            onChange={singleMediaFormik.handleChange}
            onBlur={singleMediaFormik.handleBlur}
            borderRadius={'md'}
          />

          {singleMediaFormik.touched.message && singleMediaFormik.errors.message ? (
            <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.message}</Text>
          ) : null}
        </Box>

        <Box direction="column" mb={4}>
          <Flex alignItems="center" mb={2} gap={2}>
            <Text fontWeight="bold" fontSize={'14px'}>Headline</Text>
            <Tooltip
              borderRadius={5}
              label={
                <Box fontSize="sm" p="5px">
                  <Text>
                    Add up to five brief headlines to let people know what your ad is about. Each
                    headline can have a maximum of 255 characters. Headlines won't appear in all
                    placements.
                  </Text>
                </Box>
              }
              fontSize="md">
              <InfoOutlineIcon pointerEvents="all" />
            </Tooltip>
          </Flex>
          <Input
            size={'sm'}
            placeholder="Tell people what your ad is about..."

            borderRadius={'md'}
            name="name"
            value={singleMediaFormik.values.name}
            onChange={singleMediaFormik.handleChange}
            onBlur={singleMediaFormik.handleBlur}
          />

          {singleMediaFormik.touched.name && singleMediaFormik.errors.name ? (
            <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.name}</Text>
          ) : null}
        </Box>

        {activeDestinationType === 'APP' ? null :
          <Box direction="column" mb={'10px'}>
            <Flex alignItems="center" mb={2} gap={2}>
              <Text fontWeight="bold" fontSize={'14px'}>Description</Text>
              <Tooltip
                borderRadius={5}
                label={
                  <Box fontSize="sm" p="5px">
                    <Text>
                      Add up to five link descriptions to emphasise why people should visit your
                      website. This won't appear in all placements.
                    </Text>
                  </Box>
                }
                fontSize="md">
                <InfoOutlineIcon pointerEvents="all" />
              </Tooltip>
            </Flex>
            <Textarea
              size={'sm'}
              placeholder="Include additional details"

              borderRadius={'md'}
              name="description"
              value={singleMediaFormik.values.description}
              onChange={singleMediaFormik.handleChange}
              onBlur={singleMediaFormik.handleBlur}
              rows={3}
            />
            {singleMediaFormik.touched.description && singleMediaFormik.errors.description ? (
              <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.description}</Text>
            ) : null}
          </Box>
        }

        {activeDestinationType === 'APP' ? (
          <Box direction="column">
            <Flex alignItems="center" mb={2} gap={2}>
              <Text fontWeight="bold" fontSize={'14px'}>Call to action</Text>
              <Tooltip
                borderRadius={5}
                label={
                  <Box fontSize="sm" p="5px">
                    <Text>Show a button or link on your ad that represents the action you want people to take.</Text>
                  </Box>
                }
                fontSize="md"
              >
                <InfoOutlineIcon pointerEvents="all" />
              </Tooltip>
            </Flex>
            <Select
              name="type"
              borderRadius={'md'}
              value={singleMediaFormik.values.type}
              onChange={singleMediaFormik.handleChange}
              onBlur={singleMediaFormik.handleBlur}
              size={'sm'}
              isDisabled={userInfo?.role !== 'client'}
            >
              {call_to_action_options_app_promptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
            {singleMediaFormik.touched.type && singleMediaFormik.errors.type ? (
              <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.type}</Text>
            ) : null}
          </Box>
        ) : activeDestinationType === 'ON_AD' && objective === 'OUTCOME_LEADS' ? (
          <Box direction="column" mb={'10px'}>
            <Flex alignItems="center" mb={2} gap={2}>
              <Text fontWeight="bold" fontSize="14px">Call to action</Text>
              <Tooltip
                borderRadius={5}
                label={
                  <Box fontSize="sm" p="5px">
                    <Text>This is the only available option.</Text>
                  </Box>
                }
                fontSize="md"
              >
                <InfoOutlineIcon pointerEvents="all" />
              </Tooltip>
            </Flex>
            <Select
              name="type"
              borderRadius="md"
              value={singleMediaFormik.values.type}
              onChange={singleMediaFormik.handleChange}
              onBlur={singleMediaFormik.handleBlur}
              size="sm"
            >
              {call_to_action_options_instantForms?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </Box>
        ) : activeDestinationType === 'PHONE_CALL' ? (
          <Box direction="column" mb={'10px'}>
            <Flex alignItems="center" mb={2} gap={2}>
              <Text fontWeight="bold" fontSize="14px">Call to action</Text>
              <Tooltip
                borderRadius={5}
                label={
                  <Box fontSize="sm" p="5px">
                    <Text>This is the only available option.</Text>
                  </Box>
                }
                fontSize="md"
              >
                <InfoOutlineIcon pointerEvents="all" />
              </Tooltip>
            </Flex>
            <Select
              name="type"
              borderRadius="md"
              value={singleMediaFormik.values.type}
              onChange={singleMediaFormik.handleChange}
              onBlur={singleMediaFormik.handleBlur}
              size="sm"
              isDisabled
            >
              <option value="CALL_NOW">Call Now</option>
            </Select>
          </Box>
        ) : <Box direction="column" mb={'10px'}>
          <Flex alignItems="center" mb={2} gap={2}>
            <Text fontWeight="bold" fontSize="14px">Call to action</Text>
            <Tooltip
              borderRadius={5}
              label={
                <Box fontSize="sm" p="5px">
                  <Text>This is the only available option.</Text>
                </Box>
              }
              fontSize="md"
            >
              <InfoOutlineIcon pointerEvents="all" />
            </Tooltip>
          </Flex>
          <Select
            name="type"
            borderRadius="md"
            value={singleMediaFormik.values.type}
            onChange={singleMediaFormik.handleChange}
            onBlur={singleMediaFormik.handleBlur}
            size="sm"
          >
            {call_to_action_options?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </Box>
        }

        {activeDestinationType == 'WEBSITE' ? (
          <>
            <Divider pt={2} />
            {selectedAdAccounts.map((account, index) => {
              const link = links.find(item => item.adsAccountId === account.adsAccountId)?.link || '';
              const isUrlValid = isValidUrl(link);
              const hasFocus = isFocused[account.adsAccountId];

              return (
                <Flex key={`${account.adsAccountId}-${index}`} direction="column">
                  <Flex alignItems="center" gap={2}>
                    <Text fontWeight="bold" fontSize="14px">
                      {truncateString(account.adsAccountName, 40)}
                    </Text>
                    <Text fontSize="12px">({account.adsAccountId})</Text>
                  </Flex>
                  <Flex alignItems="center" mb={'6px'}>
                    <Text fontWeight="bold" fontSize="14px">
                      Website URL
                    </Text>
                    <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                    <Tooltip
                      borderRadius={5}
                      label={
                        <Box fontSize="sm" p="5px">
                          <Text>Enter the URL for the webpage you want people to visit</Text>
                        </Box>
                      }
                      fontSize="md"
                    >
                      <InfoOutlineIcon pointerEvents="all" />
                    </Tooltip>
                  </Flex>
                  <Input
                    type="url"
                    name={`link[${index}].link`}
                    bg="#fff"
                    borderRadius="md"
                    placeholder="Enter URL"
                    value={link}
                    onChange={(e) => handleLinkChange(account.adsAccountId, e.target.value)}
                    onFocus={() => handleFocus(account.adsAccountId)}
                    size="sm"
                  />
                  <Flex mt={1} mb={2}>
                    <Button onClick={() => {
                      setUrlModalOpen(true)
                      setSelectedAccountId(account?.adsAccountId);
                    }}
                    variant="link"
                    color='brand'>
                      <Text fontSize={'12px'}>{'Build a URL parameter'}</Text>
                    </Button>
                  </Flex>
                  {/* Show validation error if URL is empty or invalid */}
                  {hasFocus && link === '' && (
                    <Text color="red.500" fontSize="12px" mt={'5px'}>
                      {'URL is required'}
                    </Text>
                  )}
                  {hasFocus && !isUrlValid && link !== '' && (
                    <Text color="red.500" fontSize="12px" mt={'5px'}>
                      {'Please enter valid URL'}
                    </Text>
                  )}
                </Flex>
              );
            })}
          </>
        ) : null}

        {activeDestinationType == 'APP' ? (
          <>
            {selectedAdAccounts.map((account, index) => {
              const link = links?.find(item => item.adsAccountId === account.adsAccountId)?.link || '';
              const customId = customIds?.find(item => item.adsAccountId === account.adsAccountId)?.app_product_page_id || '';

              return (
                <Box key={`${account.adsAccountId}-${index}`} borderWidth="1px" borderColor={boxBorder} borderRadius="md" p={2} mt={2}>
                  <Flex direction="column">
                    <Flex alignItems="center" gap={2} mb={2}>
                      <Text fontWeight="bold" fontSize="14px">
                        {truncateString(account.adsAccountName, 40)}
                      </Text>
                      <Text fontSize="12px">({account.adsAccountId})</Text>
                    </Flex>

                    <Flex alignItems="center" mb={'6px'} gap={2}>
                      <Text fontWeight="bold" fontSize="14px">
                        Deferred deep link
                      </Text>
                      <Tooltip
                        borderRadius={5}
                        label={
                          <Box fontSize="sm" p="5px">
                            <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                            <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                            <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                            <Box>
                              <Text>* Android app link</Text>
                              <Text>* Custom URL scheme</Text>
                              <Text>* Facebook app link</Text>
                            </Box>
                          </Box>
                        }
                        fontSize="md"
                      >
                        <InfoOutlineIcon pointerEvents="all" />
                      </Tooltip>
                    </Flex>

                    <Input
                      type="url"
                      name={`link[${index}].link`}
                      bg="#fff"
                      borderRadius="md"
                      placeholder="Enter a deferred deep link URL"
                      value={link}
                      onChange={(e) => handleLinkChange(account.adsAccountId, e.target.value)}
                      onFocus={() => handleFocus(account.adsAccountId)}
                      size="sm"
                    />
                  </Flex>

                  <Flex direction="column" gap={1} mt={3}>
                    <Flex alignItems="center" gap={2}>
                      <Text fontWeight="bold" fontSize="14px">Custom store listing</Text>
                      <Tooltip
                        borderRadius={5}
                        label={
                          <Box fontSize="sm" p="5px">
                            <Text fontWeight="bold">Using a custom store listing</Text><br />
                            <Text mb={2}>A custom store listing ID sends people to a landing page you've customized...</Text>
                          </Box>
                        }
                        fontSize="md"
                      >
                        <InfoOutlineIcon pointerEvents="all" />
                      </Tooltip>
                    </Flex>

                    <Input
                      type="text"
                      name={`customId[${index}].app_product_page_id`}
                      bg="#fff"
                      borderRadius="md"
                      placeholder="Enter custom store listing ID"
                      value={customId}
                      onChange={(e) => handleCustomIdChange(account.adsAccountId, e.target.value)}
                      onFocus={() => handleFocus(account.adsAccountId)}
                      size="sm"
                    />
                  </Flex>
                </Box>
              );
            })}
          </>
        ) : null}

        {activeDestinationType === 'PHONE_CALL' ? (
          <Box>
            {selectedAdAccounts.map((account, index) => {
              const phoneNumber = phoneNumbers.find(item => item.adsAccountId === account.adsAccountId)?.phoneNumber || '';
              const isValidNo = isValidPhoneNumber(phoneNumber);
              const hasFocus = isFocused[account.adsAccountId];

              return (
                <Flex key={`${account.adsAccountId}-${index}`} direction="column">
                  <Flex alignItems="center" gap={2}>
                    <Text fontWeight="bold" fontSize="14px">
                      {truncateString(account.adsAccountName, 40)}
                    </Text>
                    <Text fontSize="12px">({account.adsAccountId})</Text>
                  </Flex>
                  <Flex alignItems="center" mb={2} gap={2}>
                    <Text fontWeight="bold" fontSize={'14px'}>Call now</Text>
                    <Tooltip
                      borderRadius={5}
                      label={
                        <Box fontSize="sm" p="5px">
                          <Text>You can use a different phone number for each carousel card. This can be helpful if you have different phone numbers or extensions.</Text>
                        </Box>
                      }
                      fontSize="md"
                    >
                      <InfoOutlineIcon pointerEvents="all" />
                    </Tooltip>
                  </Flex>
                  <PhoneInput
                    country={'in'}
                    value={phoneNumber}
                    onChange={(value) => handlePhoneNumberChange(account.adsAccountId, value)}
                    name={`phoneNumber[${index}].phoneNumber`}
                    inputProps={{
                      name: `phoneNumber[${index}].phoneNumber`,
                      required: true,
                    }}
                    enableSearch={true}
                    searchPlaceholder="Search"
                    onFocus={() => handleFocus(account.adsAccountId)}
                  />
                  {/* Show validation error if phone number is empty or invalid */}
                  {hasFocus && phoneNumber === '' && (
                    <Text color="red.500" fontSize="12px" mt={'5px'}>
                      {'Phone number is required'}
                    </Text>
                  )}
                  {hasFocus && !isValidNo && phoneNumber !== '' && (
                    <Text color="red.500" fontSize="12px" mt={'5px'}>
                      {'Please enter valid phone number'}
                    </Text>
                  )}
                </Flex>
              );
            })}
          </Box>
        ) : null}


        {activeDestinationType === 'ON_AD' && objective === 'OUTCOME_LEADS' ? (
          <>
            <Divider mt={2} />
            <Box>
              {selectedAdAccounts.map((account, index) => {

                const matchedAccount = adData?.adsAccounts.find(
                  (adAccount) => adAccount?.adsAccountId === account?.adsAccountId
                );

                if (!matchedAccount) return null;

                if (isInstantFormsLoading) {
                  return <Text>Loading...</Text>;
                }

                if (instantFormsError || !instantForms) {
                  return <Text color="red.500" fontSize={'12px'}>{instantFormsError ? instantFormsError?.message : 'Failed to load instant forms.'}</Text>;
                }

                // Filter instantForms based on the matchedAccount's page_id
                const filteredInstantForms = instantForms
                  .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
                  .flat() // Flatten the array to get all forms in one array
                  .filter((form) => form?.page_id === matchedAccount?.page_id);

                return (
                  <Flex key={`${account.adsAccountId}-${index}`} direction="column" mb={2}>
                    {/* Account Details */}
                    <Flex alignItems="center" gap={2}>
                      <Text fontWeight="bold" fontSize="14px">
                        {truncateString(account.adsAccountName, 40)}
                      </Text>
                      <Text fontSize="12px">({account.adsAccountId})</Text>
                    </Flex>

                    <Flex alignItems="center" mb={2} gap={2}>
                      <Text fontWeight="bold">Instant form</Text>
                      <Tooltip
                        borderRadius={5}
                        label={
                          <Box fontSize="sm" p="5px">
                            <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                          </Box>
                        }
                        fontSize="md"
                      >
                        <InfoOutlineIcon pointerEvents="all" />
                      </Tooltip>
                    </Flex>

                    {/* Table Layout */}
                    {filteredInstantForms.length > 0 ? (
                      <RadioGroup onChange={(value) => handleLinkChange(account?.adsAccountId, value)} colorScheme="brand">
                        <Table variant="simple">
                          <Thead>
                            <Tr>
                              <Th textTransform={'none'} color={'none'} fontSize="14px">Form title</Th>
                              <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {filteredInstantForms.map((form) => (
                              <Tr key={form?.id}>
                                <Td>
                                  <Flex alignItems="center" gap={2}>
                                    <Radio value={form?.id} />
                                    <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                      {form?.name}
                                    </Text>
                                  </Flex>
                                </Td>
                                <Td>
                                  <Text fontSize={'12px'}>
                                    {new Date(form?.created_time).getFullYear()}-
                                    {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                    {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                  </Text>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </RadioGroup>
                    ) : (
                      <Text fontSize="14px" color="gray.500">No form data available</Text>
                    )}
                  </Flex>
                );
              })}
            </Box>
          </>
        ) : null}


        {activeDestinationType === 'APP' ? null :
          <>
            <Divider mt={2} />
            {selectedAdAccounts.map((account, index) => {
              const urlTag = url_tags.find(item => item.adsAccountId === account.adsAccountId)?.url_tags || '';

              return (
                <Flex key={`${account.adsAccountId}-${index}`} direction="column">
                  <Flex alignItems="center" gap={2}>
                    <Text fontWeight="bold" fontSize="14px">
                      {truncateString(account.adsAccountName, 40)}
                    </Text>
                    <Text fontSize="12px">({account.adsAccountId})</Text>
                  </Flex>
                  <Flex alignItems={'center'}>
                    <Text mb={2} fontWeight="bold" fontSize="14px">
                      URL parameters{" "}
                      {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                      <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                    </Text>
                    <Tooltip
                      borderRadius={5}
                      label={
                        <Box fontSize="sm" p={'5px'}>
                          <Text >
                            Add parameters to the end of your website URL to track where your visitors are coming from.
                          </Text>
                        </Box>
                      }
                      fontSize="md"
                    >
                      <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                    </Tooltip>
                  </Flex>
                  <Input
                    type="url"
                    name={`urlTag[${index}].urlTag`}
                    bg="#fff"
                    borderRadius="md"
                    placeholder="key1=value1&key2=value2"
                    value={urlTag}
                    onChange={(e) => handleUrlTagChange(account.adsAccountId, e.target.value)}
                    onFocus={() => handleFocus(account.adsAccountId)}
                    size="sm"
                  />
                  <Flex mt={1} mb={2}>
                    <Button onClick={() => {
                      setUrlParamModalOpen(true)
                      setSelectedAccountId(account?.adsAccountId);
                    }}
                    variant="link"
                    color='brand'>
                      <Text fontSize={'12px'}>{'Build a URL parameter'}</Text>
                    </Button>
                  </Flex>
                </Flex>
              );
            })}
          </>
        }

        {/* Save Button */}
        <Flex justifyContent="flex-start" mt={'10px'}>
          <Button
            colorScheme="brand"
            onClick={() => singleMediaFormik.handleSubmit()}
            isLoading={isAdsCreating || isAdspressoAdsetUpdating}
            size={'sm'}
            isDisabled={
              !singleMediaFormik.values.mediaFiles.length > 0 ||
              !hasSameDestinationType ||
              ((activeDestinationType === 'WEBSITE' || activeDestinationType === 'ON_AD') && !allLinksAdded) ||
              (activeDestinationType === 'PHONE_CALL' && !allPhoneNumbersAdded) ||
              isAccountsMatching
            }
          >
            Save
          </Button>
        </Flex>

        {/* {uploadedCreativesList?.length > 0 ? (
          <>
            <Divider my={'10px'} />
            <Flex direction="column" gap={2} >
              {uploadedCreativesList}
            </Flex>
          </>
        ) : null} */}

      </Flex>
    </>
  );
}

export default SizeMediaCreative;